import { render, staticRenderFns } from "./RegisterJWT.vue?vue&type=template&id=20b0418e"
import script from "./RegisterJWT.vue?vue&type=script&lang=js"
export * from "./RegisterJWT.vue?vue&type=script&lang=js"
import style0 from "./RegisterJWT.vue?vue&type=style&index=0&id=20b0418e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports